import { UPDATE_IS_CHAT_SDK_INIT } from '../actions';

export const isChatSdkInit = (state = false, action) => {
  switch (action.type) {
    case UPDATE_IS_CHAT_SDK_INIT: {
      return action.isInit;
    }
    default:
      return state;
  }
};
